// extracted by mini-css-extract-plugin
export default {"Cart_details_img":"ProductCartDetails_Cart_details_img__L6F8-","Cart_details_info":"ProductCartDetails_Cart_details_info__kaG9O"};